export default [
  {
  path:'/admin/canvas/canvas',
  name:'Canvas',
  component: () => import('@/views/canvas/canvas'),
  meta:{
    title:'canvas画布',
    keepAlive:false
  }
}]



// WEBPACK FOOTER //
// ./src/router/canvas.js